module.exports = __webpack_public_path__ + "static/fonts/BMHANNAAir_ttf.ttf?e08a8dee";